"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
// Generated from ../../../cs/src/Contracts/TunnelAccessControlEntry.cs
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TunnelAccessControlEntry = void 0;
var TunnelAccessControlEntry;
(function (TunnelAccessControlEntry) {
    /**
     * Constants for well-known identity providers.
     */
    let Providers;
    (function (Providers) {
        /**
         * Microsoft (AAD) identity provider.
         */
        Providers["Microsoft"] = "microsoft";
        /**
         * GitHub identity provider.
         */
        Providers["GitHub"] = "github";
        /**
         * SSH public keys.
         */
        Providers["Ssh"] = "ssh";
        /**
         * IPv4 addresses.
         */
        Providers["IPv4"] = "ipv4";
        /**
         * IPv6 addresses.
         */
        Providers["IPv6"] = "ipv6";
        /**
         * Service tags.
         */
        Providers["ServiceTag"] = "service-tag";
    })(Providers = TunnelAccessControlEntry.Providers || (TunnelAccessControlEntry.Providers = {}));
})(TunnelAccessControlEntry = exports.TunnelAccessControlEntry || (exports.TunnelAccessControlEntry = {}));
//# sourceMappingURL=tunnelAccessControlEntry.js.map